import { ReactNode } from 'react';
import { UiText } from 'znanie-uikit';

import css from './HtmlContent.module.scss';

interface IProps {
  html: string | ReactNode;
  truncate?: boolean;
  size?: number;
  char?: string;

  onClickMore?(isOpen: boolean): void;
}

export default function HtmlContent({
  html,
  truncate,
  size = 1000,
  char = '',
  onClickMore,
}: IProps) {
  if (typeof html !== 'string') {
    return <div className={css.block}>{html}</div>;
  }

  return (
    <>
      {truncate ? (
        <div className={css.block}>
          <UiText.Wrapper
            size={size}
            withFormat
            isBlur
            char={char}
            onClickMore={onClickMore}
          >
            {html}
          </UiText.Wrapper>
        </div>
      ) : (
        <div className={css.block} dangerouslySetInnerHTML={{ __html: html }} />
      )}
    </>
  );
}
